import { FormFieldsData } from 'framework/form';
import { ProjectReviewPeriod, ProjectReviewPeriodInfo, ProjectReviewResult } from '../types';
import { PROJECT_REVIEW_COMPARE_MODE } from './constants';

type ProjectReviewFormData = FormFieldsData & {
  compareMode: string;
  previousReviewDate?: string;
  reviewDate: Nullable<string>;
  startDate: Nullable<string>;
  endDate: Nullable<string>;
};

export const getProjectReviewFormData = (
  latestProjectReview: ProjectReviewPeriodInfo,
  currentReviewDate: string,
): ProjectReviewFormData => ({
  compareMode: latestProjectReview.lastReviewEndDate
    ? PROJECT_REVIEW_COMPARE_MODE.SINCE_PREVIOUS_REVIEW
    : PROJECT_REVIEW_COMPARE_MODE.CUSTOM_PERIOD,
  previousReviewDate: latestProjectReview.lastReviewEndDate ?? undefined,
  reviewDate: currentReviewDate,
  startDate: null,
  endDate: null,
});

export const getProjectReviewFormDataAfterStart = (review: ProjectReviewResult): ProjectReviewFormData => {
  const isSincePreviousReview = review.periodMode === 'SINCE_LAST_REVIEW';

  return {
    compareMode: isSincePreviousReview
      ? PROJECT_REVIEW_COMPARE_MODE.SINCE_PREVIOUS_REVIEW
      : PROJECT_REVIEW_COMPARE_MODE.CUSTOM_PERIOD,
    previousReviewDate: isSincePreviousReview ? review.from : undefined,
    reviewDate: isSincePreviousReview ? review.to : null,
    startDate: isSincePreviousReview ? null : review.from,
    endDate: isSincePreviousReview ? null : review.to,
  };
};

export const getProjectReviewPeriod = (data: FormFieldsData): ProjectReviewPeriod => {
  if (data.compareMode === PROJECT_REVIEW_COMPARE_MODE.SINCE_PREVIOUS_REVIEW) {
    return { periodMode: 'SINCE_LAST_REVIEW', from: data.previousReviewDate, to: data.reviewDate };
  }

  return { periodMode: 'CUSTOMER_PERIOD', from: data.startDate, to: data.endDate };
};
